const DateIcon = () => {
  return (
    <div>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="25"
        height="24"
        viewBox="0 0 25 24"
        fill="none"
      >
        <path
          d="M8.31885 2V5"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3188 2V5"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.31885 13H15.3188"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.31885 17H12.3188"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.3188 3.5C19.6488 3.68 21.3188 4.95 21.3188 9.65V15.83C21.3188 19.95 20.3188 22.01 15.3188 22.01H9.31885C4.31885 22.01 3.31885 19.95 3.31885 15.83V9.65C3.31885 4.95 4.98885 3.69 8.31885 3.5H16.3188Z"
          stroke="#0D0D0D"
          strokeWidth="2"
          strokeMiterlimit="10"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </div>
  );
};

export default DateIcon;
